import Header from "./Header";
import Body from "./Body";
import SubHeader from "./SubHeader";
export default { Header, Body, SubHeader };
